import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../../../core/services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(): boolean {
    // Se o login não estiver habilitado, permite acesso
    if (!this.authService.isLoginEnabled) {
      return true;
    }

    // Se estiver habilitado e o usuário estiver logado, permite acesso
    if (this.authService.isAuthenticated) {
      return true;
    }

    // Se não estiver logado, inicia o fluxo de login Azure
    this.authService.login();
    return false;
  }
}
